import { IH2HStanding } from "core-integration/src/store/leagues/types";
import Link from "plos/src/components/links/Link";
import { textTruncate } from "plos/src/styles";
import { Cell, Row } from "react-aria-components";
import { entryLink } from "../../../Classic/StandingsClassic/StandingsClassicTable/standingsClassicTable.css";
import Movement from "../../../Movement";
import { leaguesTableCell } from "../../../shared";
import {
  LeaguesTableCellVariants,
  leaguesTableRow,
  LeaguesTableRowVariants,
} from "../../../shared/styles/leaguesTableStyles.css";
import { rankCell } from "./standingsH2HTable.css";

interface StandingsH2HRowProps {
  rowData: IH2HStanding;
  eventId: number;
  rowStyleVariant: LeaguesTableRowVariants;
  cellStyleVariants: LeaguesTableCellVariants;
}

const StandingsH2HRow = ({
  rowData,
  eventId,
  rowStyleVariant,
  cellStyleVariants,
}: StandingsH2HRowProps) => {
  const {
    rank,
    entry,
    entry_name: entryName,
    player_name: playerName,
    last_rank: lastRank,
    matches_won: matchesWon,
    matches_drawn: matchesDrawn,
    matches_lost: matchedLost,
    points_for: pointsFor,
    total,
  } = rowData;

  return (
    <Row className={leaguesTableRow[rowStyleVariant]}>
      <Cell className={leaguesTableCell(cellStyleVariants)}>
        <div className={rankCell}>
          {rank}
          <Movement lastRank={lastRank} rank={rank} />
        </div>
      </Cell>
      <Cell className={leaguesTableCell(cellStyleVariants)}>
        <div className={textTruncate}>
          {entry ? (
            <Link to={`/entry/${entry}/event/${eventId}`} className={entryLink}>
              <strong>{entryName}</strong>
            </Link>
          ) : (
            <strong>{entryName}</strong>
          )}
          <br />
          <span>{playerName}</span>
        </div>
      </Cell>
      <Cell
        className={leaguesTableCell({ ...cellStyleVariants, numeric: true })}
      >
        {matchesWon}
      </Cell>
      <Cell
        className={leaguesTableCell({ ...cellStyleVariants, numeric: true })}
      >
        {matchesDrawn}
      </Cell>
      <Cell
        className={leaguesTableCell({ ...cellStyleVariants, numeric: true })}
      >
        {matchedLost}
      </Cell>
      <Cell
        className={leaguesTableCell({ ...cellStyleVariants, numeric: true })}
      >
        {pointsFor}
      </Cell>
      <Cell
        className={leaguesTableCell({ ...cellStyleVariants, numeric: true })}
      >
        {total}
      </Cell>
    </Row>
  );
};

export default StandingsH2HRow;
